module.exports = __webpack_public_path__ + "static/media/26.98563d75.jpg";